export function InitialUrlQueries() {
    var _a;
    var query = new URLSearchParams(window.location.search);
    return {
        itemId: parseInt((_a = query.get('itemId')) !== null && _a !== void 0 ? _a : '0', 10)
    };
}
export function UpdateUrlQueries(params) {
    var query = new URLSearchParams();
    if (!!params.itemId && params.itemId > 0) {
        query.set('itemId', params.itemId.toString());
    }
    else {
        return;
    }
    window.history.replaceState(params, '', "".concat(window.location.pathname, "?").concat(query.toString()));
}
